<template>
  <div class="c-app" :class="{ 'c-dark-theme': darkMode }">
    <meta charset="utf-8">
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheHeader from './TheHeader'

export default {
  name: 'TheContainer',
  components: {
    TheHeader
  },
  computed: {
    darkMode () {
      return this.$store.getters['coreui/darkMode']
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
